import React from 'react';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { SectionContentTitleText } from 'app-components/home/sections/components/SectionContentTitleText';
import { SectionTextContentMetaInfo } from 'app-components/home/sections/components/SectionTextContentMetaInfo';

interface SectionContentLiteTextItemProps {
  content: ContentPublicRelayDto;
  profile: ProfileLitePublicRelayDto;
  onClick?: () => void;
}

export const SectionContentLiteTextItem = ({ content, profile, onClick }: SectionContentLiteTextItemProps) => (
  <div onClick={onClick} className="flex flex-col gap-1 w-full min-w-0 h-[56px]">
    <SectionContentTitleText content={content} />
    <SectionTextContentMetaInfo content={content} profile={profile} />
  </div>
);
